module.exports = __webpack_public_path__ + "static/img/bg2.a8f7973c.png";